<script setup>
import {ref} from "vue";
import PaymentModal from "@/components/ecosystem/PaymentModal.vue";

const showModal = ref(false);
const paymentModal = ref(null);

function showPaymentModal() {
    showModal.value = false;
    paymentModal.value.open();
}

function open() {
    showModal.value = true;
}

defineExpose({
    open
});
</script>

<template>
    <div>
        <Modal v-model="showModal" hide-footer hide-header modal-class="modal-upsell">
            <div class="modal-content__inner modal-content__inner--dark">
                <header class="modal-header">
                    <button @click="showModal = false" class="close"></button>
                </header>

                <h5 class="modal-title">Unlock Full SwitchPitch Capabilities</h5>

                <ul class="list-upsell">
                    <li>AI search with prioritized scoring</li>
                    <li>Adoption-based market intelligence</li>
                    <li>AI-generated custom reports</li>
                </ul>

                <footer class="modal-footer">
                    <a @click="showPaymentModal()">Activate Full Access</a>
                </footer>
            </div>
        </Modal>

        <PaymentModal
            ref="paymentModal"
            @closed="showModal = true"
        />
    </div>
</template>

<style scoped>
</style>
